import cuckoo from "../cuckoo/cuckoo"
import repeatDownloadWithFallbackUntil from "../../../../app/scripts/tools/repeatDownloadWithFallbackUntil"
import { PAYMENT_ERROR_KEY, PAYMENT_ERROR_TYPES, cuckooEvents } from "../../consts/enums"
import { formatZoozAddPaymentMethodError } from "./ZoozHelper"

const zoozApi = {
  sandbox: null,
  production: null,
}

const zoozId = "skypicker_new"
const zoozScriptUrlLocal = "/scripts/zooz.js"
const zoozScriptUrlRemote =
  "https://app.zooz.com/mobile/checkoutapi/js/checkout-ext-api.js"

function _init({ isSandbox }) {
  const key = isSandbox ? "sandbox" : "production"

  return repeatDownloadWithFallbackUntil({
    url: zoozScriptUrlRemote,
    retries: 3,
    timeout: 15000, // TODO: Check
    fallbackUrl: zoozScriptUrlLocal,
    check() {
      return typeof window.Zooz !== "undefined"
    },
  }).then(() => {
    if (!zoozApi[key]) {
      try {
        zoozApi[key] = new Zooz.Ext.External({
          // eslint-disable-line no-undef
          isSandbox,
          uniqueId: zoozId,
        })
      } catch (err) {
        cuckoo.critical(cuckooEvents.PAYMENT_ZOOZ_INITIALIZE_ERROR, err)
      }
    }
    return zoozApi[key]
  })
}

export function sendPayment({
  paymentToken,
  email,
  number,
  name,
  expirationMonth,
  expirationYear,
  cvv,
  isSandbox,
  bid,
  abid,
  finalCashInCurrency,
  currency,
  authToken, // Needed just for correct behaviour of skymock
}) {
  cuckoo.track(cuckooEvents.PAYMENT_ZOOZ_ADD_PAYMENT_METHOD_REQUEST, {
    paymentToken,
    isSandbox,
    bid,
    abid,
    finalCashInCurrency,
    currency,
  })

  if (paymentToken.startsWith("MOCK")) {
    // Skymock
    switch (paymentToken) {
      case "MOCK/SUCCESS":
        return Promise.resolve({ paymentMethodToken: authToken })
      case "MOCK/FAILURE/user":
        return Promise.reject({
          type: PAYMENT_ERROR_TYPES.USER,
          code: PAYMENT_ERROR_KEY.BANK_REFUSED,
          msg: "Mocked user error",
        })
      case "MOCK/FAILURE/system":
        return Promise.reject({ type: PAYMENT_ERROR_TYPES.SYSTEM, msg: "Mocked system error" })
      case "MOCK/FAILURE/unknown":
      default:
        return Promise.reject({ type: PAYMENT_ERROR_TYPES.UNKNOWN, msg: "Mocked unknown error" })
    }
  }

  return new Promise((resolve, reject) => {
    _init({ isSandbox }).then(zooz => {
      const payload = {
        paymentToken,
        email,
        paymentMethod: {
          paymentMethodType: "CreditCard",
          paymentMethodDetails: {
            cardNumber: number,
            cardHolderName: name,
            month: expirationMonth,
            year: expirationYear,
            cvvNumber: cvv,
          },
          configuration: {
            rememberPaymentMethod: false, // required field
          },
        },
      }

      const onSuccess = res => {
        const duration = new Date().getTime() - startTime
        cuckoo.track(cuckooEvents.PAYMENT_ZOOZ_ADD_PAYMENT_METHOD_SUCCESS, {
          bid,
          abid,
          finalCashInCurrency,
          currency,
          duration,
        })

        resolve({
          paymentMethodToken: res["paymentMethodToken"],
        })
      }

      const onFailure = res => {
        const duration = new Date().getTime() - startTime
        cuckoo.track(cuckooEvents.PAYMENT_ZOOZ_ADD_PAYMENT_METHOD_FAIL, {
          bid,
          abid,
          finalCashInCurrency,
          currency,
          duration,
        })

        reject(Object.assign({}, res, formatZoozAddPaymentMethodError(res.errorMessage)))
      }

      // TODO: Add timeout
      const startTime = new Date().getTime()
      zooz.addPaymentMethod(payload, onSuccess, onFailure)
    })
  })
}
